<template>
  <div v-if="requestsLoaded && allPermissionRequests.permissionRequests.length > 0" class="info-okvir modra-barva-info">
    <div style="font-size: 18px;margin-bottom: 5px;">
      Dodeljene pravice, ki čakajo vašo potrditev:
    </div>
    <template v-for="(request,index) in allPermissionRequests.permissionRequests">
      <el-divider v-if="index!==0" class="dividerNoMargin"></el-divider>
      <div style="display: flex; padding: 5px;">
        <div style="margin: auto 10px auto 0px; flex: auto;">
          {{ request.permissionGiverName }} vam je dodelil pravico
          "<span style="font-weight: bold;">{{ request.permissionName }}</span>" na projektu
          "<span style="font-weight: bold;">{{ request.resourceName }}</span>". <br />Želite sprejeti dodeljeno pravico?
        </div>

        <div style="text-align: right; width: 110px;">
          <!--        <el-tooltip placement="left">-->
          <!--          <div slot="content">-->
          <!--            <div>Datum:-->
          <!--              <b>{{ request.date }}</b>-->
          <!--            </div>-->
          <!--            <div>Dodelil:-->
          <!--              <b>{{ request.permissionGiverEmail }}</b>-->
          <!--            </div>-->
          <!--            <div>Status:-->
          <!--              <b v-if="request.requestId !== null" style="color:blue;">čaka potrditev</b>-->
          <!--              <b v-else style="color:green;">aktiven</b>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--          <el-button icon="el-icon-info" plain size="mini" style="margin: 5px; font-size: 16px;">-->
          <!--          </el-button>-->
          <!--        </el-tooltip>-->
          <el-button
            icon="el-icon-check"
            plain size="mini"
            style="margin: 5px 0px 5px 5px; font-size: 16px; border-color: #67c23a; color: #67c23a; background-color: #f2faee;"
            title="Sprejmi pravico"
            v-if="
                          request.requestId !== null
                        "
            @click="acceptPermissionRequest(request)"
          >
          </el-button>
          <el-button
            icon="el-icon-close"
            plain size="mini"
            style="margin: 5px 0px 5px 0px; font-size: 16px;"
            title="Zavrni pravico"
            v-if="
                          request.requestId !== null
                        "
            @click="declinePermissionRequest(request)"
            type="danger"
          >
          </el-button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import CloudPermissionRequests from '../../../../../assets/js/T2Cloud/CloudPermissionRequests'
import {Button, Col, Row, Select, Option, Card, Dialog, Divider, Tooltip} from 'element-ui'

export default {
  name: 'CloudPermissionRequests',
  components: {
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Select.name]: Select,
    [Option.name]: Option,
    [Card.name]: Card,
    [Dialog.name]: Dialog,
    [Divider.name]: Divider,
    [Tooltip.name]: Tooltip
  },
  data () {
    return {
      allPermissionRequests: new CloudPermissionRequests(),
      requestsLoaded: false
    }
  },
  async created () {
    await this.reloadPermissionRequests()
  },
  methods: {
    async acceptPermissionRequest (request) {
      try {
        await request.acceptPermissionRequest()
        this.$emit('requestChanged')
        await this.reloadPermissionRequests()
      } catch (e) {
        this.ShowErrorMessage({message: e.message})
      }
    },
    async declinePermissionRequest (request) {
      try {
        await request.declinePermissionRequest()
        this.$emit('requestChanged')
        await this.reloadPermissionRequests()
      } catch (e) {
        this.ShowErrorMessage({message: e.message})
      }
    },
    async reloadPermissionRequests () {
      try {
        this.requestsLoaded = false
        await this.allPermissionRequests.loadAllPermissionRequests()
        this.requestsLoaded = true
      } catch (e) {
        this.ShowErrorMessage({message: e.message})
      }
    }
  }
}
</script>

<style scoped>
.dividerNoMargin {
  margin: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/T2Cloud/CloudPermissionRequests.vue